<template>
  <div>    
    <!-- 入荷処理ダイアログ -->
    <ListDialog2 ref="createPurchaseDeliveryDialog" :title="cpdIsTransitPost ? '未着品処理':'入荷処理'" :buttonNames="buttonNames" modelName="OrderItem" storageKey="listDialog2_CreatePurchaseDelivery" :captions="cpdCaptions" :widths="cpdWidths" :requireds="cpdRequireds" :showAdd="false" :showRemove="true" :showLeading="true" :execWithIndex="submitCreatePurchaseDelivery" :height="235" :width="1000">
    <!-- 入荷処理ダイアログ ヘッダ項目 -->
    <template slot="header" slot-scope="{ editor }">
        <EditPanel>
        <!-- 入荷処理ダイアログ ヘッダ項目 左側 -->
        <template slot="left">
            <ComboBox title="ワークフロー(入荷)" :value.sync="cpdWorkflowId" :editor="editor" :required="true" :enabled="$api.perms.hasWorkflow('purchaseDelivery')" list="workflow_purchaseDelivery" :nullValue="0" @changed="onChangeWorkflow()" tooltip="入荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【入荷管理】になっているデータから選択ができます。"/>    
            <ComboBox title="ワークフロー(仕入)" :value.sync="cpdInvoiceWorkflowId" :editor="editor" :required="true"  :enabled="$api.perms.hasWorkflow('purchaseInvoice')" list="workflow_purchaseInvoice"  :nullValue="0" @changed="onChangeWorkflow()" tooltip="仕入計上時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【仕入計上】になっているデータから選択ができます。" />                        
            <AutoComplete title="担当者" :value.sync="cpdPic" :editor="editor" list="user" :required="true" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
            <TextBox title="入荷管理番号" :value.sync="cpdRefNo" :editor="editor" length="30" tooltip="任意で入荷に対して管理番号を入力することができます。"/>
            <AtcCounterpart title="仕入先" :value.sync="cpdSupplier" :editor="editor" :needsSupplier="true" :enabled="false" tooltip="発注一覧で登録した【仕入先】が表示されます。【発注明細一覧】からは変更できません。"/>              
            <Calendar title="仕入日" :value.sync="cpdBookDate" :editor="editor" @changed="onChangeCpdBookDate" v-if="cpdIsTransitPost" tooltip="仕入れを計上する日付を設定できます。商品が入荷した日ではなく買掛金が発生する日付です。"/>
            <TextBox v-if="cpdIsTransitPost && hasLicenseCurrency" title="取引通貨" :value="cpdCurrencyCode | currency" :editor="editor" :enabled="false" />
            <NumericBox v-if="cpdIsTransitPost && hasLicenseCurrency" title="計上レート" :value.sync="cpdExchangeRate" :editor="editor" :required="true" min="0.000001" max="999.999999" decimalsInput="6" />              
            <Calendar title="入荷日" :value.sync="cpdDeliveryDate" :editor="editor" :required="cpdDeliveryFlag != cpdDirectFlag" :min="minDeliveryDate()" :deletable="false" @changed="onChangeCpdDeliveryDate" tooltip="商品が入荷した日付です。【在庫区分】が【在庫】の場合は倉庫に入荷した日付、【直送】の場合は出荷先に商品が到着した日付になります。"/>
            <Calendar title="支払予定日" :value.sync="cpdDueDate" :editor="editor"  v-if="cpdIsTransitPost" />              
            <RadioButton :enabled="cpdAllCheckedHasSales" title="納入区分" :value.sync="cpdDeliveryFlag" :list="$api.useStockFunction ? 'deliveryFlagsHasServices' : 'deliveryFlagsHasServicesNoStock'" :editor="editor" @update:value="onChangeCpdDeliveryFlag" tooltip="受注データが紐づいている場合、入荷した商品を在庫とするか、お客様に直送するかの区分を選択することができます。"/>

            <AtcCounterpart title="入庫倉庫" :value.sync="cpdWarehouse" :editor="editor" :required="true" :needsWarehouse="true" v-if="cpdDeliveryFlag == cpdStockFlag" tooltip="発注した商品を入荷時に保管する倉庫を選択します。【取引先一覧】の【取引先種別】が【倉庫】になっているデータが選択できます。"/>
            <AtcCounterpart title="納入先" :value.sync="cpdReceiver" :editor="editor" :required="true" :needsCustomer="true" :needsReceiver="true" v-if="cpdDeliveryFlag == cpdDirectFlag" @update:value="onChangeReceiver()" tooltip="【納入区分】が直送の場合のみ表示されます。納入先を編集することができます。"/>
            <TextBox title="出荷管理番号" :value.sync="cpdSalesRefNo" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" :length="30" tooltip="【納入区分】が直送の場合のみ表示されます。入力した番号は入荷処理と同時に作成される出荷データの【出荷管理番号】に反映されます。"/>              
            <!-- 納入区分によってダイアログのサイズが変更されるため、変更されないようブランク項目を追加してバランスをとる⇒余白が大きく明細部が見にくいため詰める -->
            <!-- <TextBox title="" value="" :enabled="false" v-if="cpdDeliveryFlag != cpdDirectFlag" /> -->
            <!-- <TextBox title="" value="" :enabled="false" v-if="cpdDeliveryFlag == cpdServicesFlag" /> -->
        </template>
        <!-- 入荷処理ダイアログ ヘッダ項目 右側 -->
        <template slot="right">
            <TextBox title="納入先名称" :value.sync="cpdReceiverName" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先名称を編集することができます。"/>
            <TextBox title="納入先担当部署名" :value.sync="cpdReceiverPicSection" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先担当部署名を編集することができます。"/>
            <TextBox title="納入先担当者" :value.sync="cpdReceiverPic" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="30" tooltip="【納入区分】が直送の場合のみ表示されます。納入先担当者を編集することができます。"/>
            <TextBox title="納入先敬称" :value.sync="cpdReceiverPICHonorificTitle" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="30" tooltip="【納入区分】が直送の場合のみ表示されます。納入先の敬称を編集することができます。"/>
            <TextBox title="納入先郵便番号" :value.sync="cpdReceiverPostalCode" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先郵便番号を編集することができます。"/>
            <TextBox title="納入先住所1" :value.sync="cpdReceiverAddress1" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先住所1を編集することができます。"/>
            <TextBox title="納入先住所2" :value.sync="cpdReceiverAddress2" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先住所2を編集することができます。"/>
            <TextBox title="納入先住所3" :value.sync="cpdReceiverAddress3" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="50" tooltip="【納入区分】が直送の場合のみ表示されます。納入先住所3を編集することができます。"/>
            <TextBox title="納入先電話番号" :value.sync="cpdReceiverTelNo" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="20" tooltip="【納入区分】が直送の場合のみ表示されます。納入先電話番号を編集することができます。"/>
            <TextBox title="納入先FAX番号" :value.sync="cpdReceiverFaxNo" :editor="editor" v-if="cpdDeliveryFlag == cpdDirectFlag" length="20" tooltip="【納入区分】が直送の場合のみ表示されます。納入先FAX番号を編集することができます。"/>
        </template>
        </EditPanel>
    </template>
    <!-- 入荷処理ダイアログ 一覧項目 -->
    <b-link slot="leading" slot-scope="{ item, editor, row}" :editor="editor" @click="onCopyRow(item,row)" class="cx_button_copy"><i class="material-icons small valign">file_copy</i></b-link>
    <TextBox :slot="cpdSlots[0]" slot-scope="{ item, editor }" :value="item.orderItemNo" :editor="editor" :enabled="false" />
    <TextBox :slot="cpdSlots[1]" slot-scope="{ item, editor }" :value="item.commodity.name" :editor="editor" :enabled="false" />
    <TextBox :slot="cpdSlots[2]" slot-scope="{ item, editor }" :value="item.sku ? item.sku.name : ''" :editor="editor" :enabled="false" />
    <AtcConversion :slot="cpdSlots[3]" slot-scope="{ item, editor }" :value.sync="item.uom2" :editor="editor" :enabled="false" />
    <NumericBox :slot="cpdSlots[4]" slot-scope="{ item, editor }" :value="item.backOrderQuantity" :editor="editor" :enabled="false" :decimals="item.commodity.quantityScale" />
    <NumericBox :slot="cpdSlots[5]" slot-scope="{ item, editor }" :value.sync="item.deliveringQuantity" :editor="editor" :required="true" :min="-1 * item.backOrderQuantity" :max="item.backOrderQuantity" :nullValue="0" :decimals="item.commodity.quantityScale" />
    <NumericBox :slot="cpdSlots[6]" slot-scope="{ item, editor }" :value="item.unitPrice" :editor="editor" :enabled="false" :decimals="item.commodity.stockPriceScale" />
    <TextBox :slot="cpdSlots[7]"  slot-scope="{ item, editor }" :value="item.taxCode | taxCode" :editor="editor" :enabled="false" />

    <TextBox :slot="cpdSlots[8]"  slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText1)" length="50" />
    <TextBox :slot="cpdSlots[8]"  slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText1)" length="50" />
    <TextBox :slot="cpdSlots[9]"  slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText2)" length="50" />
    <TextBox :slot="cpdSlots[9]"  slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText2)" length="50" />
    <TextBox :slot="cpdSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText3)" length="50" />
    <TextBox :slot="cpdSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText3)" length="50" />
    <TextBox :slot="cpdSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText4)" length="50" />
    <TextBox :slot="cpdSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText4)" length="50" />
    <TextBox :slot="cpdSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText5)" length="50" />
    <TextBox :slot="cpdSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText5)" length="50" />
    <TextBox :slot="cpdSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText6)" length="50" />
    <TextBox :slot="cpdSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveText6)" length="50" />
    <TextBox :slot="cpdSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo1)" length="200" />
    <TextBox :slot="cpdSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo1)" length="200" />
    <TextBox :slot="cpdSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo2)" length="200" />
    <TextBox :slot="cpdSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo2)" length="200" />
    <TextBox :slot="cpdSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo3)" length="200" />
    <TextBox :slot="cpdSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" :enabled="isEditable(tenantSettings.usedTypeDetailReserveMemo3)" length="200" />
    <Calendar :slot="cpdSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate1)"/>
    <Calendar :slot="cpdSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate1)"/>
    <Calendar :slot="cpdSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate2)"/>
    <Calendar :slot="cpdSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate2)"/>
    <Calendar :slot="cpdSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate3)"/>
    <Calendar :slot="cpdSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :deletable="true" :enabled="isEditable(tenantSettings.usedTypeDetailReserveDate3)"/>
    <AutoComplete :slot="cpdSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category"/>
    <AutoComplete :slot="cpdSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category"/>
    <AutoComplete :slot="cpdSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category"/>
    <AutoComplete :slot="cpdSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category"/>
    <AutoComplete :slot="cpdSlots[22]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category"/>
    <AutoComplete :slot="cpdSlots[22]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category"/>
    <TextBox :slot="cpdSlots[23]" slot-scope="{ item, editor }" :value="item.order.refNo" :editor="editor" :enabled="false" />
    <TextBox :slot="cpdSlots[24]" slot-scope="{ item, editor }" :value="item.salesRefNo" :editor="editor" :enabled="false" />
    <TextBox :slot="cpdSlots[25]" slot-scope="{ item, editor }" :value="item.salesCustomerOrderNo" :editor="editor" :enabled="false" />
    </ListDialog2>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class CreatePurchaseDelivery extends Vue {
  
  @Prop() public checkedOrderItems:Array<Common.SalesOrderItem>; 
  @Prop() public parentMainList:Components.ListView;
  @Prop() public purchaseOrderItems:Components.GrdVoucherItem;
  @Prop() public isTransitPost:boolean;
  @Prop() public order:Common.PurchaseOrder;
  @Prop() public parent:any;
  @Prop() public isItemFlag:boolean;
  // ワークフロー処理用プロパティ
  public buttonNames: Array<string> = null;
  public buttonIndexIdArray: Array<{index:number,actionId:number}> =null;
  // 入荷処理用プロパティ
  public usedTypes = Common.UsedTypes;  
  public cpdInputType:Common.InputTypes = Common.InputTypes.PurchaseOrder;
  public cpdCaptions = new Array();
  public cpdWidths = new Array();
  public cpdSlots = new Array();
  public cpdRequireds = new Array();
  public cpdGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('明細番号', 125).required(),
      new Common.GridItemConfiguration('商品', 250).required(),
      new Common.GridItemConfiguration('SKU', 125),
      new Common.GridItemConfiguration('単位', 125).required(),
      new Common.GridItemConfiguration('発注残数量', 125).required(),
      new Common.GridItemConfiguration('入荷数量', 125).required(),
      new Common.GridItemConfiguration('単価', 125).required(),
      new Common.GridItemConfiguration('税区分', 125).required(),
      new Common.GridItemConfiguration('発注管理番号', 150),
      new Common.GridItemConfiguration('受注管理番号', 150),
      new Common.GridItemConfiguration('顧客注文番号', 150),
    ],
    8, //税区分の次を予備項目の挿入位置に指定
    'col'
  );
  public cpdOrder: Common.PurchaseOrder = new Common.PurchaseOrder();
  public cpdSelectedIndex: number = 0;
  public cpdIsTransitPost:boolean = false;
  public cpdSegmentId: number = null;
  public cpdPic: string = '';
  public cpdRefNo: string = '';
  public cpdSupplierId: number = null;
  public cpdSupplier: Common.Counterpart = null;  
  public cpdBookDate: Date = new Date;
  public cpdClosingDate: Date = null;
  public cpdDueDate: Date = null;
  public cpdDeliveryFlag: number = 0;
  public cpdScheduledDeliveryDate: Date = new Date;
  public cpdDeliveryDate: Date = new Date;
  public cpdWarehouse: Common.Counterpart =null;
  public cpdSalesRefNo: string = '';
  public cpdReceiver: Common.Counterpart =null;
  public cpdReceiverPostalCode: string = '';
  public cpdReceiverAddress1: string = '';
  public cpdReceiverAddress2: string = '';
  public cpdReceiverAddress3: string = '';
  public cpdReceiverName: string = '';
  public cpdReceiverPicSection: string = '';
  public cpdReceiverPic: string = '';
  public cpdReceiverPICHonorificTitle: string = '';
  public cpdReceiverTelNo: string = '';
  public cpdReceiverFaxNo: string = '';
  public cpdStockFlag: Common.DeliveryFlags = Common.DeliveryFlags.Stock;
  public cpdDirectFlag: Common.DeliveryFlags = Common.DeliveryFlags.Direct;
  public cpdServicesFlag: Common.DeliveryFlags = Common.DeliveryFlags.Services;
  public cpdWorkflowId: number = 0;
  public cpdInvoiceWorkflowId: number = 0;
  public cpdExchangeRate :number = 0;
  public cpdCurrencyCode : string = '';
  public cpdAllCheckedHasSales : boolean = false;
  public tenantSettings: Common.TenantSettings = null;

    public mounted(){
    this.cpdIsTransitPost = this.isTransitPost;
    // 選択した発注の明細が変更されないよう修正
    let copyCheckedOrderItems = new Array<Common.PurchaseOrderItem>();
    this.checkedOrderItems.forEach(obj=>{
      let copy = obj.copy();
      copy.state = obj.state;
      copy.isClosed = obj.isClosed;
      copyCheckedOrderItems.push(copy);
    });
    this.checkedOrderItems = copyCheckedOrderItems;
    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.filter(item=>item.state < Common.OrderItemStatus.PurchaseOrderUndelivered).length > 0){
      this.$api.modal.show('', '入荷可能な明細を選択して下さい。', true, null);
      return;
    }
    if (this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.segment.id != item.order.segment.id).length > 0){
      this.$api.modal.show('', '部門の異なる発注明細を、同じ入荷伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.counterpartId != item.order.counterpartId).length > 0){
      this.$api.modal.show('', '仕入先の異なる発注明細を、同じ入荷伝票にまとめることはできません。', true, null);
      return;
    }

    // 警告メッセージ表示
    var alertMessage = '';
    if(this.checkedOrderItems.filter(item => (this.checkedOrderItems[0].order.warehouseId != item.order.warehouseId)).length > 0){
      alertMessage = '倉庫の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverPostalCode != item.order.outputReceiverPostalCode).length > 0){
      alertMessage = '納入先詳細(郵便番号)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverAddress1 != item.order.outputReceiverAddress1).length > 0){
      alertMessage = '納入先詳細(住所1)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverAddress2 != item.order.outputReceiverAddress2).length > 0){
      alertMessage = '納入先詳細(住所2)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverAddress3 != item.order.outputReceiverAddress3).length > 0){
      alertMessage = '納入先詳細(住所3)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverName != item.order.outputReceiverName).length > 0){
      alertMessage = '納入先詳細(名称)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverPICSection != item.order.outputReceiverPICSection).length > 0){
      alertMessage = '納入先詳細(担当部署名)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverPIC != item.order.outputReceiverPIC).length > 0){
      alertMessage = '納入先詳細(担当者)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverPICHonorificTitle != item.order.outputReceiverPICHonorificTitle).length > 0){
      alertMessage = '納入先詳細(敬称)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverTelNo != item.order.outputReceiverTelNo).length > 0){
      alertMessage = '納入先詳細(電話番号)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }
    else if(this.checkedOrderItems.filter(item => this.checkedOrderItems[0].order.outputReceiverFaxNo != item.order.outputReceiverFaxNo).length > 0){
      alertMessage = '納入先詳細(FAX番号)の異なる発注明細が選択されています。入荷処理を続行した場合、入力値で上書きされます。';
    }

    this.cpdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseDelivery');
    this.cpdInvoiceWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseInvoice');
    this.onChangeWorkflow();

    var showDialog = () =>{
      // 入荷数量の初期値設定
      if(this.$api.tenantSettings.purchaseDeliveryQuantitySetInitial == true) this.checkedOrderItems.forEach(item => item.deliveringQuantity = item.backOrderQuantity);
      // 明細の予備項目表示の可変対応
      var reserveItems = this.$api.tenantSettings.GetGridItems(true,true,false,false,true); 
      this.cpdGridConfig.setVariableItems(reserveItems);
      this.cpdCaptions =this.cpdGridConfig.gridCaptions;
      this.cpdWidths = this.cpdGridConfig.gridWidths;
      this.cpdSlots = this.cpdGridConfig.gridSlots;
      this.cpdRequireds = this.cpdGridConfig.gridRequireds;

      // プロパティの初期化
      this.cpdCurrencyCode = this.checkedOrderItems[0].order.currencyCode;      
      this.cpdOrder = this.order == null ? this.checkedOrderItems[0].order.copy() : this.order;
      this.cpdSegmentId = this.cpdOrder.segment.id;
      this.cpdPic = this.$api.auth.userId;
      this.cpdRefNo = '';
      // this.cpdSupplierId = this.cpdOrder.counterpartId;
      this.cpdSupplier = this.cpdOrder.counterpart;
      this.cpdBookDate = new Date().getCalendarDate();
      this.cpdClosingDate = this.cpdOrder.counterpart.getClosingDate(this.cpdBookDate, this.$api.tenantSettings);
      this.cpdDueDate = this.cpdOrder.counterpart.getPaymentDate(this.cpdBookDate, this.$api.tenantSettings);
      this.cpdDeliveryFlag = this.cpdOrder.deliveryFlag;
      this.cpdDeliveryDate = this.checkedOrderItems[0].scheduledDeliveryDate ?  this.checkedOrderItems[0].scheduledDeliveryDate : new Date().getCalendarDate();
      this.tenantSettings = this.$api.tenantSettings;
      // 入荷処理の場合、入荷日の初期値を元に仕入日や支払予定日を設定
      this.onChangeCpdDeliveryDate();

      this.cpdAllCheckedHasSales = true;
      this.checkedOrderItems.forEach(obj=>{
        if(!obj.salesOrderItemNo){
          this.cpdAllCheckedHasSales=false;
          this.cpdDeliveryFlag=Common.DeliveryFlags.Stock;
        }
      });

      if (this.cpdDeliveryFlag == Common.DeliveryFlags.Stock){
        this.cpdScheduledDeliveryDate = this.checkedOrderItems[0].scheduledDeliveryDate ?  this.checkedOrderItems[0].scheduledDeliveryDate : new Date().getCalendarDate();
        // this.cpdDeliveryDate = new Date().getCalendarDate();
        // 在庫となっている場合、商品全てが棚卸対象なら役務等にする
        if(this.checkedOrderItems.filter(item=>item.isNoStock==false).length==0) this.cpdDeliveryFlag=Common.DeliveryFlags.Services;
      } else {
        this.cpdScheduledDeliveryDate = this.cpdBookDate;
      }
      if(this.cpdDeliveryFlag!=Common.DeliveryFlags.Services){
        this.cpdWarehouse = this.cpdOrder.warehouse;
        this.cpdSalesRefNo = '';
        if(this.cpdOrder.receiver == null && this.cpdOrder.receiverId != null) this.$api.find('Counterpart', [this.cpdOrder.receiverId]).then(res => this.cpdReceiver = res);
        else this.cpdReceiver = this.cpdOrder.receiver;
        this.cpdReceiverPostalCode = this.cpdOrder.outputReceiverPostalCode;
        this.cpdReceiverAddress1 = this.cpdOrder.outputReceiverAddress1;
        this.cpdReceiverAddress2 = this.cpdOrder.outputReceiverAddress2;
        this.cpdReceiverAddress3 = this.cpdOrder.outputReceiverAddress3;
        this.cpdReceiverName = this.cpdOrder.outputReceiverName;
        this.cpdReceiverPicSection = this.cpdOrder.outputReceiverPICSection;
        this.cpdReceiverPic = this.cpdOrder.outputReceiverPIC;
        this.cpdReceiverPICHonorificTitle = this.cpdOrder.outputReceiverPICHonorificTitle;
        this.cpdReceiverTelNo = this.cpdOrder.outputReceiverTelNo;
        this.cpdReceiverFaxNo = this.cpdOrder.outputReceiverFaxNo;
      }

      this.onChangeCpdBookDate();
      // ダイアログを表示
      (this.$refs.createPurchaseDeliveryDialog as Components.ListDialog2).items = this.checkedOrderItems;
      (this.$refs.createPurchaseDeliveryDialog as Components.ListDialog2).showDialog();
    }

    if(alertMessage.length>0){
      // 警告メッセージを表示後、ダイアログを表示
      this.$api.modal.show('', alertMessage, true, showDialog);
    }else{
      // ダイアログを表示
      showDialog();
    }
  }

  //納入先を変更時に
  public onChangeReceiver(){
        this.cpdReceiverName = this.cpdReceiver.name;
        this.cpdReceiverPicSection = this.cpdReceiver.picSection;
        this.cpdReceiverPic = this.cpdReceiver.pic;
        this.cpdReceiverPICHonorificTitle = this.cpdReceiver.honorificTitle;
        this.cpdReceiverPostalCode = this.cpdReceiver.postalCode;
        this.cpdReceiverAddress1 = this.cpdReceiver.address1;
        this.cpdReceiverAddress2 = this.cpdReceiver.address2;
        this.cpdReceiverAddress3 = this.cpdReceiver.address3;
        this.cpdReceiverTelNo = this.cpdReceiver.telNo;
        this.cpdReceiverFaxNo = this.cpdReceiver.faxNo;
  }

  //  入荷処理ダイアログの納入区分変更時に関連項目を初期化する
  public onChangeCpdDeliveryFlag(flag: Common.DeliveryFlags){
    if(flag == Common.DeliveryFlags.Direct){
      // 直送変更時･･･入荷日、入庫倉庫を初期化
      this.cpdScheduledDeliveryDate = this.cpdBookDate;
      this.cpdDeliveryDate = this.cpdBookDate;
      this.cpdWarehouse = null;
    }else if(flag == Common.DeliveryFlags.Stock){
      // 在庫変更時･･･出荷管理番号、納入先詳細を初期化
      this.cpdSalesRefNo = '';
      this.cpdReceiverPostalCode = this.cpdOrder.outputReceiverPostalCode;
      this.cpdReceiverAddress1 = this.cpdOrder.outputReceiverAddress1;
      this.cpdReceiverAddress2 = this.cpdOrder.outputReceiverAddress2;
      this.cpdReceiverAddress3 = this.cpdOrder.outputReceiverAddress3;
      this.cpdReceiverName = this.cpdOrder.outputReceiverName;
      this.cpdReceiverPicSection = this.cpdOrder.outputReceiverPICSection;
      this.cpdReceiverPic = this.cpdOrder.outputReceiverPIC;
      this.cpdReceiverPICHonorificTitle = this.cpdOrder.outputReceiverPICHonorificTitle;
      this.cpdReceiverTelNo = this.cpdOrder.outputReceiverTelNo;
      this.cpdReceiverFaxNo = this.cpdOrder.outputReceiverFaxNo;
    }else{
      // 役務等変更時･･･出荷管理番号、納入先詳細、入庫倉庫を初期化
      this.cpdSalesRefNo = '';
      this.cpdReceiverPostalCode = '';
      this.cpdReceiverAddress1 = '';
      this.cpdReceiverAddress2 = '';
      this.cpdReceiverAddress3 = '';
      this.cpdReceiverName = '';
      this.cpdReceiverPicSection = '';
      this.cpdReceiverPic = '';
      this.cpdReceiverPICHonorificTitle = '';
      this.cpdReceiverTelNo = '';
      this.cpdReceiverFaxNo = '';
      this.cpdWarehouse = null;
    }
  }
  //仕入日の最小値
  public minDeliveryDate(): Date{
    if(!this.cpdIsTransitPost) return null;
    return this.cpdBookDate;
  }
  //仕入日変更時の動作
  public onChangeCpdBookDate(){
    this.cpdClosingDate = this.cpdOrder.counterpart.getClosingDate(this.cpdBookDate, this.tenantSettings);
    this.cpdDueDate = this.cpdOrder.counterpart.getPaymentDate(this.cpdBookDate, this.tenantSettings);  
    if (this.cpdIsTransitPost){
      this.cpdDeliveryDate = this.cpdBookDate;
      //売上日が変更された場合に為替レートを取得する
      const query = new Common.GetExchangeRateQuery();
      query.currency = this.cpdCurrencyCode;
      query.startDate = this.cpdBookDate;
      this.$api.execute(query).then(res => {
        const exchangeRate = res as Common.ExchangeRate;
        this.cpdExchangeRate = exchangeRate ? exchangeRate.rate : 1;
      });                
    }
  }
  //入荷日変更時の動作
  public onChangeCpdDeliveryDate(){
    if (this.cpdIsTransitPost == false){
      this.cpdBookDate = this.cpdDeliveryDate;
      this.onChangeCpdBookDate();
    }
  }
  //入荷処理の編集可能項目
  public isEditable(usedType: Common.UsedTypes){
    if(usedType == Common.UsedTypes.StockAttribute) return true;
    if(usedType == Common.UsedTypes.DeliveryMemo) return true;
    return false;
  }
  
  // 入荷処理の実行
  public async submitCreatePurchaseDelivery(list: Array<Common.OrderItem>, index:number) {
    // クエリの設定
    var query: Common.CreatePuchaseDeliveryQuery =new Common.CreatePuchaseDeliveryQuery();
    query.workflowId = this.cpdWorkflowId;
    query.actionId = this.buttonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    query.invoiceWorkflowId = this.cpdInvoiceWorkflowId;
    query.isTransitPost = this.cpdIsTransitPost;
    query.purchaseOrderItems = list;
    query.pic = this.cpdPic;
    query.refNo = this.cpdRefNo;
    query.bookDate = this.cpdBookDate;
    query.deliveryFlag = this.cpdDeliveryFlag;
    query.scheduledDeliveryDate = this.cpdScheduledDeliveryDate;
    query.deliveryDate = this.cpdDeliveryDate;
    query.dueDate = this.cpdDueDate;
    query.warehouse = this.cpdWarehouse;
    query.salesRefNo = this.cpdSalesRefNo;
    query.receiver = this.cpdReceiver;
    query.outputReceiverPostalCode = this.cpdReceiverPostalCode;
    query.outputReceiverAddress1 = this.cpdReceiverAddress1;
    query.outputReceiverAddress2 = this.cpdReceiverAddress2;
    query.outputReceiverAddress3 = this.cpdReceiverAddress3;
    query.outputReceiverName = this.cpdReceiverName;
    query.outputReceiverPICSection = this.cpdReceiverPicSection;
    query.outputReceiverPIC = this.cpdReceiverPic;
    query.outputReceiverPICHonorificTitle = this.cpdReceiverPICHonorificTitle;
    query.outputReceiverTelNo = this.cpdReceiverTelNo;
    query.outputReceiverFaxNo = this.cpdReceiverFaxNo;
    query.exchangeRate = this.cpdExchangeRate;

    (this.$refs.createPurchaseDeliveryDialog as Components.ListDialog2).closeDialog();
    return this.$api.execute(query,true).then(res => {
      // 画面を更新
      if(this.isItemFlag){
        this.parentMainList.reload().then(()=>{ if(this.purchaseOrderItems) this.purchaseOrderItems.onVoucherNoChanged(); });
      }
      else{
        this.$api.find('Order', [((this.parentMainList as Components.ListView).selected as Common.PurchaseOrder).orderNo]).then(res2 => 
          this.parent.onWorkflow(this.parentMainList.currentId,res2));
      }
      //トライアル中はロードマップを更新
      if(this.$api.license.isTrial) this.$api.updateRoadmapRatio();     
      var delivery = res as Common.Delivery;
        this.$api.modal.show('処理結果','以下の入荷伝票が作成されました。',false,()=>{
            this.$router.push(String.format('/purchase/PurchaseDelivery?deliveryNo={0}',delivery.deliveryNo));
        },[new Common.ModalLink(delivery.deliveryNo,String.format('/purchase/PurchaseDelivery?deliveryNo={0}',delivery.deliveryNo))],
        '伝票に移動する','閉じる');
      return true;
    }).catch(()=>{
      return false;});          
  }
  public onChangeWorkflow(){
    this.buttonNames=new Array();
    this.buttonIndexIdArray = new Array();
    var buttonIndex = 0;
  
    if(this.cpdIsTransitPost){
      // 未着品処理
      this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
      this.buttonNames.push("仕入保存");
      if(this.cpdInvoiceWorkflowId != 0){
        let actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseInvoice', this.cpdInvoiceWorkflowId, Common.InvoiceStatus.PurchasePostWaiting);
        actions.forEach(action => {
          this.buttonNames.push(action.actionName);
          this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
        });
      }
    }else{
      // 入荷処理
      this.buttonIndexIdArray.push({index:buttonIndex++,actionId:0})
      this.buttonNames.push("入荷保存");
      if(this.cpdWorkflowId != 0){
        let actions = this.$api.perms.getWorkflowActionsHasPermission('purchaseDelivery', this.cpdWorkflowId, Common.DeliveryStatus.PurchaseDeliverySaving);
        actions.forEach(action => {
          this.buttonNames.push(action.actionName);
          this.buttonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
        });
      }
    }
  }
  public onCopyRow(item:Common.PurchaseOrder, index: number){
  var copyObj = item.copy();
  copyObj.state = item.state;
  copyObj.isClosed = item.isClosed;
  (this.$refs.createPurchaseDeliveryDialog as Components.ListDialog2).items.splice(index,0,copyObj);
  }
}
</script>
<style lang="scss">
  .cx_button_copy{
    width: 30px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #666666;
    &:hover {
      color: #242020;
      text-decoration:none;
    }
    i {
      font-size: 22px;
    }
  }

</style>